import React from 'react';
import statusMap from './StockAvailabilityStatusMap';
import reeceMarker from '../../../assets/images/icon-marker-reece-arrow-down.svg';
import actrolMarker from '../../../assets/images/icon-marker-actrol-arrow-down.svg';
import metalflexMarker from '../../../assets/images/icon-marker-metalflex-arrow-down.svg';


const StockAvailabilityBranch = ({branch, status}) => {
  let logoPath;
  switch(branch.company) {
    case "reece":
      logoPath = reeceMarker;
      break;
    case "actrol":
      logoPath = actrolMarker;
      break;
    case "metalflex":
      logoPath = metalflexMarker;
      break;
    default:
      logoPath = reeceMarker;
  }

  return (
    <li className="store-finder__result-list-item sf-result-list-item">
      <div className="store-finder__result-list-item-main sf-mini-panel">
        <img className="store-finder__brand-icon" src={logoPath} alt={branch.name}/>
        <div className="store-finder__result-store-info">
          <a className="store-finder__result-link sf-result-list-link">
            <h2 className="store-finder__result-list-heading">
              {branch.name}
              {branch.companyNameBusinessUnitNamesHtml && (
                <span className="store-finder__result-store-type">
                <div dangerouslySetInnerHTML={{__html: branch.companyNameBusinessUnitNamesHtml}} />
                </span>
              )}
            </h2>
            <div className="store-finder__result-store-address">
              {branch.address.address}, {branch.address.suburb} {branch.address.state} {branch.address.postcode}
            </div>
          </a>
          <div className="store-finder__result-contact-info">
            <a href="tel:" className="store-finder__result-contact-phone">
              {branch.phoneNumber}
            </a>
          </div>
          <div className="store-finder__result-direction-info">
            <span className={`store-finder-stock-check-list__stock-status ${statusMap[status].cssClass}`}>{statusMap[status].text}</span>
          </div>

        </div>
      </div>
    </li>
  );
};

export default StockAvailabilityBranch;